import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup ,Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
// import { CartService } from 'src/app/shared/services/cart.service';
import { CartService } from 'src/shared/services/cart.service';
declare var Razorpay: any;
import Swal from 'sweetalert2';
import { DataService } from 'src/shared/data/data.service';

@Component({
  selector: 'app-checkout-modal',
  templateUrl: './checkout-modal.component.html',
  styleUrl: './checkout-modal.component.scss'
})
export class CheckoutModalComponent  implements OnInit{
  @Input() show: boolean = false;
  @Input() orderData: any;
  @Output() close = new EventEmitter<void>();

  form!: FormGroup;
  showPassword = false;
  customerExists = false;
  isProcessing = false;
  private razorpayInstance: any;
  addresses: any[] = [];
  selectedAddressId: number | null = null;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private cart: CartService,
    public data: DataService
  ) {}

ngOnInit() {
  this.form = this.fb.group({
    name: [
      '',
      [
        Validators.required,
        Validators.minLength(3),
        Validators.pattern(/^[a-zA-Z ]+$/)
      ]
    ],
    mobile: [
      '',
      [
        Validators.required,
        Validators.pattern(/^[6-9]\d{9}$/)   // Indian 10-digit mobile
      ]
    ],
    email: [
      '',
      [
        Validators.required,
        Validators.email
      ]
    ],
    password: [
      '',
      
    ]
  });

  this.checkCustomer();
}

  checkCustomer() {
  const isLoggedIn = localStorage.getItem('is_logged_in');

  if (isLoggedIn === 'true') {

    this.customerExists = true;
    this.showPassword = false;   // ✅ HIDE password
   
    const customerData = {
      email: localStorage.getItem('customer_email'),
      customer_id: localStorage.getItem('customer_id'),
      name: localStorage.getItem('customer_name'),
      mobile: localStorage.getItem('mobile_number'),
    };

    this.form.patchValue({
      email: customerData.email,
      customer_id: customerData.customer_id,
      name: customerData.name,
      mobile: customerData.mobile,
    });
    this.loadCustomerAddresses();
  } else {
    this.customerExists = false;
    this.showPassword = true;
  }
}

  // placeOrder() {
  //   const payload = {
  //     ...this.form.value,
  //     cart_items: this.orderData.items,
  //     total: this.orderData.total
  //   };

  //   this.http.post('http://127.0.0.1:8000/place_order/', payload)
  //     .subscribe((res:any) => {

  //     if (res.user_id) {
  //       // ⭐ Store identity for later (testimonial, login, history)
  //       localStorage.setItem('customer_user_id', res.user_id);
  //       localStorage.setItem('customer_name', this.form.value.name);
  //       localStorage.setItem('is_logged_in', 'true');
  //       alert('Account created! You can now track orders and add testimonials.');
  //     }

  //       alert('Order placed successfully!');
  //       this.cart.clearCart();
  //       this.close.emit();
  //       this.form.reset();
  //       this.showPassword = false;
  //     });
  // }

//   placeOrder() {
//   const payload = {
//     ...this.form.value,
//     cart_items: this.orderData.items,
//     total: this.orderData.total,
//     is_logged_in: localStorage.getItem('is_logged_in') === 'true'
//   };

//   this.http.post('http://127.0.0.1:8000/place_order/', payload)
//     .subscribe(() => {
//       alert('Order placed successfully!');
//       localStorage.setItem('order_placed',"true");
//       this.cart.clearCart();
//       this.close.emit();
//       this.form.reset();
//     });
// }


placeOrder(orderId: number) {

  if (this.form.invalid) {
    this.form.markAllAsTouched();
    return;
  }

  const payload = {
    order_id: orderId,
    ...this.form.value,
    cart_items: this.orderData.items,
    total: this.orderData.total,
    is_logged_in: localStorage.getItem('is_logged_in') === 'true'
  };

  this.http.post<any>(this.data.base_url+'place_order/', payload)
    .subscribe({
      next: (res) => { 
        if (res.status === 'success') {

  Swal.fire({
  icon: 'success',
  title: 'Order Placed!',
  html: `
    Payment Successful<br>
    Order ID: <b>${res.order_id}</b>
  `,
  confirmButtonColor: '#00bbf9'
}).then(() => {
  this.cart.clearCart();
  this.form.reset();
  this.selectedAddressId = null;
  this.isProcessing = false;
  this.close.emit();
});

  localStorage.setItem(
    'order_placed',
    'true'
  );

  if (res.user_id) {

    localStorage.setItem(
      'customer_user_id',
      res.user_id
    );

  }

  localStorage.setItem(
    'customer_name',
    this.form.value.name
  );

  localStorage.setItem(
    'is_logged_in',
    'true'
  );

  this.cart.clearCart();

  this.form.reset();

  this.selectedAddressId = null;

  this.close.emit();      // ← CLOSES POPUP

}
        else {
          alert('❌ Failed to place order. Please try again.');
        }
      },

      error: () => {
        alert('⚠️ Server error. Please try again later.');
      }
    });
}
loadCustomerAddresses() {

  const customerId = localStorage.getItem('customer_id');

  if (!customerId) {
    return;
  }

  this.http.post<any>(
    this.data.base_url+'get_customer_addresses/',
    {
      customer_id: customerId
    }
  ).subscribe({

    next: (res) => {

      if (res.status === 1) {

        this.addresses = res.addresses;

        const defaultAddress = this.addresses.find(
          (address: any) => address.is_default
        );

        if (defaultAddress) {
          this.selectedAddressId = defaultAddress.id;
        }
      }

    },

    error: (err) => {
      console.error('Failed to load addresses', err);
    }

  });
}
confirmOrder() {

  if (this.form.invalid) {

    this.form.markAllAsTouched();

    return;
  }

  if (
    localStorage.getItem('is_logged_in') === 'true'
    &&
    !this.selectedAddressId
  ) {

    Swal.fire({
      icon: 'warning',
      title: 'Address Required',
      text: 'Please select delivery address'
    });

    return;
  }

  const payload = {

    customer_id:
      localStorage.getItem('customer_id'),

    address_id:
      this.selectedAddressId,

    total:
      this.orderData.total

  };

  this.http.post<any>(
    this.data.base_url+'confirm_order/',
    payload
  )
  .subscribe({

    next: (res) => {

      if (res.status === 1) {

  console.log('Order Created', res);

  this.startRazorpay(
    res.order_id,
    res.order_code
  );

}

      else {

        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: res.message
        });

        this.isProcessing = false;

      }

    },

    error: () => {

      Swal.fire({
  icon: 'error',
  title: 'Error',
  text: 'Failed to confirm order'
});

this.isProcessing = false;

    }

  });

}
startRazorpay(
  orderId: number,
  orderCode: string
) {

  this.http.post<any>(
    this.data.base_url+'create_razorpay_order/',
    {
      order_id: orderId
    }
  ).subscribe({

    next: (res) => {

      console.log(
        'Razorpay Response',
        res
      );

      if (res.status !== 1) {

        alert(
          res.message ||
          'Unable to initiate payment'
        );

        return;
      }

      const options = {

        key: res.key,

        amount: res.amount,

        currency: res.currency,

        name: 'Sangeetha Toys',

        description:
          `Order ${orderCode}`,

        order_id:
  res.razorpay_order_id,

method: {
  upi: true,
  card: true,
  netbanking: true,
  wallet: true,
  paylater: true
},

prefill: {

          name:
            this.form.value.name,

          email:
            this.form.value.email,

          contact:
            this.form.value.mobile

        },

        theme: {
          color: '#00bbf9'
        },

        handler: (
  response: any
) => {

  console.log(
    'Payment Success',
    response
  );

  this.http.post<any>(
    this.data.base_url+'verify_payment/',
    {
      razorpay_order_id:
        response.razorpay_order_id,

      razorpay_payment_id:
        response.razorpay_payment_id,

      razorpay_signature:
        response.razorpay_signature
    }
  ).subscribe({

    next: (verifyRes) => {

      console.log(
        'Verify Response',
        verifyRes
      );

      if (verifyRes.status === 1) {

        this.razorpayInstance.close();

        this.placeOrder(orderId);

      } else {

        Swal.fire({
          icon: 'error',
          title: 'Verification Failed',
          text: verifyRes.message
        });

      }

    },

    error: () => {

      Swal.fire({
        icon: 'error',
        title: 'Verification Failed',
        text: 'Unable to verify payment'
      });

    }

  });

},

        modal: {

          ondismiss: () => {

            Swal.fire({

  icon: 'info',

  title: 'Payment Cancelled',

  text: 'Your payment was not completed.'

});

this.isProcessing = false;

          }

        }

      };

      this.razorpayInstance = new Razorpay(
        options
      );
      this.razorpayInstance.open();
    },
    error: (err) => {
      console.error(err);
      Swal.fire({
  icon: 'error',
  title: 'Payment Error',
  text: 'Unable to initiate payment'
});
this.isProcessing = false;

    }

  });

}
}

